import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { Query } from '../../../hooks/queries'
import { getRules, GetRulesArgs } from './requests/get-rules'

export const useRules = ({
  organizationUuid,
  language,
  exclusionType,
  shouldLoadAssess,
  shouldLoadProtect
}: GetRulesArgs) => {
  const { data, isLoading, isError } = useContrastQuery(
    [Query.RULES, organizationUuid, language, exclusionType],
    getRules,
    {
      organizationUuid,
      language,
      exclusionType,
      shouldLoadAssess,
      shouldLoadProtect
    }
  )

  return {
    rules: data,
    isLoading,
    isError
  }
}
